import React, {Component} from "react";
import { Header, Icon, Modal, Divider, Form, Label, Container, Select, Button, Segment, Message} from 'semantic-ui-react'
import KDatePicker from '../KDatePicker'
import KDropDown from '../KDropDown'
import UserForm from './LicenseAccessForm'
import {requiredField, validateEmail} from '../../common/clientValidators'

import moment from 'moment';

import {Field, reduxForm} from 'redux-form'





const RenderInputField = ({input,  label, meta: { touched, error }, ...rest}) =>
    <Form.Field>
        <label>{label}</label>
        <input {...input} {...rest} />
         {touched && error && <Label  basic color='red' pointing>{error}</Label>}
    </Form.Field>


const convertDate = (date) => {
    return date instanceof moment ? date.format('YYYY.MM.DD') : date;
};

class LicenseAccessAdd extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
    }

    componentWillMount() {
        this.setState({
            canSave: false,
            open: false
        })

    }

    submit = (values) => {
        const normalized_values = {
            ...values,
            license_type: [values.license_type],
            expire_date : convertDate(values.expire_date)
        };

        return this.props.addLicense(normalized_values).then(() => this.props.onClose()); //(.then((result) => {

    }


    onClick = ()  => {
        this.refs.licenseAccessForm.submit(this.props.onSubmit) // Submit form values
        //this.props.getUserEmails()*/
        this.setState(
            { open: false }
        )

    }


    updateValidationBtnState = (canSave) => {
        this.setState({
            canSave: canSave
        })
    };


    render() {
        const {  open, error, handleSubmit, pristine, submitting, initialValues, onClose, emails} = this.props
        const { canSave } = this.state;
        return <div>
            <Modal size='small' open={open} dimmer='inverted' >
                <Modal.Header>
                    <Header as='h4'>
                        <Icon.Group size='large'>
                            <Icon name='user'/>
                            <Icon corner name='write'/>
                        </Icon.Group>
                        Add license
                    </Header>
                </Modal.Header>
                <Modal.Content>
                    <UserForm ref='licenseAccessForm' onSubmit={this.submit.bind(this)}
                              onUpdateValidationState={this.updateValidationBtnState}
                              initialValues={initialValues} emails={emails}/>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={() => this.onClick()} disabled={canSave}>
                        <Icon name='write'/>Add license
                    </Button>
                    <Button onClick={() => onClose()}>
                        <Icon name='user cancel' />Cancel
                    </Button>
                </Modal.Actions>
            </Modal>

        </div>
    }
}

export default reduxForm({
    form: 'userAddValidation',

})(LicenseAccessAdd);
